/**
 * Thin wrapper for Meta Pixel + GA4 event tracking.
 * Safe to call anywhere — no-ops if the scripts haven't loaded yet.
 */

export function trackEvent(name, params = {}) {
  // Meta Pixel — standard events use `track`, custom events use `trackCustom`
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    const STANDARD = new Set([
      "PageView",
      "Lead",
      "InitiateCheckout",
      "Purchase",
      "AddToCart",
      "CompleteRegistration",
      "Contact",
      "Schedule",
      "Subscribe",
      "StartTrial",
      "SubmitApplication",
      "ViewContent",
      "Search",
    ]);
    try {
      if (STANDARD.has(name)) window.fbq("track", name, params);
      else window.fbq("trackCustom", name, params);
    } catch (_) {}
  }

  // GA4 — always via gtag('event', ...)
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    try {
      window.gtag("event", name, params);
    } catch (_) {}
  }
}

// Common helpers
export const trackLead = (source = "audit_form", extra = {}) =>
  trackEvent("Lead", { content_category: source, ...extra });

export const trackInitiateCheckout = (packageId, valueUsd) =>
  trackEvent("InitiateCheckout", {
    content_ids: [packageId],
    content_type: "product",
    currency: "USD",
    value: valueUsd,
  });

export const trackPurchase = (packageId, valueUsd) =>
  trackEvent("Purchase", {
    content_ids: [packageId],
    content_type: "product",
    currency: "USD",
    value: valueUsd,
  });

export const trackContact = (channel) =>
  trackEvent("Contact", { channel });
